export const TYPES = {
  // reducer types 
  SET_PRODUCTS: "SET_PRODUCTS",
  SELECT_PRODUCT_FILTER: "SELECT_PRODUCT_FILTER",
  ON_INITIALISATION: "ON_INITIALISATION",
  CLEAR_ALL: "CLEAR_ALL",
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  MOVE_TO_WISHLIST: "MOVE_TO_WISHLIST",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  MOVE_TO_CART: "MOVE_TO_CART",
  CLEAR_CART: "CLEAR_CART",

  //filter types
  SORT_BY_PRICE: "SORT_BY_PRICE",
  SORT_BY_DEPARTMENT: "SORT_BY_DEPARTMENT",
  SORT_BY_CATEGORY: "SORT_BY_CATEGORY",
  SORT_BY_BRAND: "SORT_BY_BRAND",
  SORT_BY_RATING: "SORT_BY_RATING",
  INCLUDE_OUT_OF_STOCK: "INCLUDE_OUT_OF_STOCK",

  //boolean state const's
  PRODUCT_CARD_HOVER_STATE: "PRODUCT_CARD_HOVER_STATE",
  SET_MOBILE_FILTER_VISIBLITY: "SET_MOBILE_FILTER_VISIBLITY",
  SET_PAYMENT_SUCCESS_MODAL_VISIBLITY: "SET_PAYMENT_SUCCESS_MODAL_VISIBLITY"

}